import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend, CartesianGrid } from 'recharts';
import { Box, Typography, useTheme } from '@mui/material';
import { formatRevenue } from '@/utils/helperFunctions';

interface Props {
  data: {
    month: string;
    this_year: number;
    last_year: number;
  }[];
}

export default function MonthlyRevenueChart({ data }: Props) {
  const theme = useTheme();

  return (
    <Box bgcolor='#fff' border='1px solid #ECECEC' borderRadius={2} p={2} my={3}>
      <Typography variant='h6' fontWeight={500}>
        Monthly Revenue Trend
      </Typography>
      <Typography variant='body2' color='#777' my={1}>
        Last 12 months vs same period last year
      </Typography>

      <ResponsiveContainer width='100%' height={300}>
        <BarChart data={data} barGap={6} margin={{ top: 20, right: 20, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray='3 3' vertical={false} />

          <XAxis dataKey='month' />
          <YAxis width={90} tickFormatter={(value) => formatRevenue(value)} />

          <Tooltip formatter={(value: number) => formatRevenue(value)} />

          <Legend verticalAlign='top' align='right' iconType='circle' wrapperStyle={{ top: -40, right: 0 }} />
          <Bar dataKey='last_year' name='Last Year' fill='#E0E0E0' radius={[6, 6, 0, 0]} />
          <Bar dataKey='this_year' name='This Year' fill={theme.palette.primary.main} radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
